export default "__VITE_ASSET__kHAPWyCv__"